import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import AttendanceTable from "@/components/AttendanceTable";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function AdminAttendance() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [teachers, setTeachers] = useState([]);
  const [teacherId, setTeacherId] = useState("all");

  useEffect(() => {
    api.get("/admin/teachers").then((r) => setTeachers(r.data)).catch(() => {});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (teacherId !== "all") params.teacher_id = teacherId;
      const { data } = await api.get("/admin/attendance", { params });
      setData(data);
    } catch (e) {
      toast.error("Failed to load attendance");
    } finally {
      setLoading(false);
    }
  }, [teacherId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="max-w-full" data-testid="admin-attendance-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-medium tracking-tight text-foreground">
        Attendance
      </h1>
      <p className="mt-1 text-muted-foreground">
        Every student across the semester's class days.
      </p>

      <div className="mt-6 flex flex-wrap items-end gap-3">
        <div className="space-y-1.5">
          <Label className="text-xs">Teacher</Label>
          <Select value={teacherId} onValueChange={setTeacherId}>
            <SelectTrigger className="h-11 w-56" data-testid="attendance-teacher-filter">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All students (school-wide)</SelectItem>
              {teachers.map((t) => (
                <SelectItem key={t.id} value={t.id}>{t.full_name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <AttendanceTable
        data={data}
        loading={loading}
        linkBase={null}
        emptyText="No students found for this filter."
      />
    </div>
  );
}
